'use client';

import { ESportsIcon, RouletteIcon, SportsIcon } from '@repo/icons';
import { useTranslations } from 'next-intl';
import Category from '@/app/[locale]/(landing)/components/common-categories/category';
import CategoryCasino from '@/assets/common/category-casino.png';
import CategoryESport from '@/assets/common/category-e-sport.png';
import CategorySport from '@/assets/common/category-sport.png';

const CommonCategories = () => {
  const t = useTranslations('landing.common-categories');

  const layoutClass =
    'flex flex-row items-center justify-between space-x-4 w-full sm:w-1/3 sm:flex-col sm:justify-center sm:space-y-4 sm:space-x-0 rtl:space-x-reverse';

  return (
    <div className="flex w-full flex-col items-center justify-center space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0 sm:rtl:space-x-reverse">
      <Category
        title={t('casino-title')}
        Icon={
          <RouletteIcon
            className="size-[18px] sm:size-auto"
            fill="#fff"
          />
        }
        img={CategoryCasino}
        href="/casino"
        className={layoutClass}
        borderGradientClass="bg-gradient-to-bl from-[var(--colors-light-000)] to-[#b45e0a]"
        bgGradientClass="bg-gradient-to-bl from-[#3f332e] to-[var(--body-bg)]"
      />
      <Category
        title={t('sports-title')}
        Icon={
          <SportsIcon
            className="size-[18px] sm:size-auto"
            fill="#fff"
          />
        }
        img={CategorySport}
        href="/sportsbook"
        className={layoutClass}
        borderGradientClass="bg-gradient-to-bl from-[var(--colors-light-000)] to-[#268812]"
        bgGradientClass="bg-gradient-to-bl from-[#1b2d30] to-[var(--body-bg)]"
      />
      <Category
        title={t('e-sports-title')}
        Icon={
          <ESportsIcon
            className="size-[18px] sm:size-auto"
            fill="#fff"
          />
        }
        img={CategoryESport}
        href="/sportsbook/e_sport/300"
        className={layoutClass}
        borderGradientClass="bg-gradient-to-bl from-[var(--colors-light-000)] to-[#8614e6]"
        bgGradientClass="bg-gradient-to-bl from-[#302c40] to-[var(--body-bg)]"
      />
    </div>
  );
};

export default CommonCategories;
